import { httpsCallable } from "firebase/functions";
import { functions } from "../libs/firebaseConfig";

const invoke = async (name, data) => (await httpsCallable(functions, name)(data)).data;
export const studentReviewApi = {
  get: (courseId) => invoke("getMyCourseReview", { courseId }),
  list: (data) => invoke("listMyCourseReviews", data),
  submit: (courseId, reviewText) => invoke("submitCourseReview", { courseId, reviewText }),
  update: (reviewId, reviewText, expectedRevision) => invoke("updateMyCourseReview", { reviewId, reviewText, expectedRevision }),
};
export const reviewFailureCode = (error) => String(error?.code || "").replace(/^functions\//, "");
export function studentReviewError(error) {
  const reason = error?.details?.reason;
  const messages = {
    "not-eligible": "ยังไม่พบสิทธิ์การส่งรีวิวที่ยืนยันได้สำหรับคอร์สนี้",
    "eligibility-evidence-ambiguous": "ยังยืนยันสิทธิ์การส่งรีวิวจากประวัติการลงทะเบียนนี้ไม่ได้ กรุณาติดต่อผู้ดูแล",
    "submissions-closed": "คอร์สนี้ปิดรับรีวิวใหม่แล้ว คุณยังแก้ไขรีวิวเดิมได้ที่รีวิวของฉัน",
    "review-deleted": "รีวิวนี้ถูกลบโดยผู้ดูแลแล้ว และไม่สามารถส่งใหม่สำหรับคอร์สเดิมได้",
    "review-rate-limit": "ส่งหรือแก้ไขรีวิวบ่อยเกินไป กรุณารอสักครู่แล้วลองใหม่",
    "remove-personal-identifiers": "กรุณาลบหมายเลขโทรศัพท์หรืออีเมลออกจากข้อความรีวิว",
    "invalid-text-length": "กรุณาเขียนรีวิว 10–2,000 ตัวอักษร",
    "invalid-text-size": "ข้อความรีวิวมีขนาดใหญ่เกินไป (ไม่เกิน 8,192 ไบต์)",
    "invalid-text-control": "ข้อความมีอักขระที่ไม่รองรับ กรุณาตรวจสอบข้อความ",
    "account-unavailable": "บัญชีนี้ยังไม่พร้อมใช้งาน กรุณาตรวจสอบการเข้าสู่ระบบ",
  };
  if (messages[reason]) return messages[reason];
  const code = reviewFailureCode(error);
  if (code === "aborted") return "รีวิวมีการเปลี่ยนแปลงแล้ว กรุณาตรวจสอบข้อความล่าสุดก่อนแก้ไขต่อ";
  if (code === "already-exists") return "คุณมีรีวิวสำหรับคอร์สนี้แล้ว กรุณาไปที่รีวิวของฉัน";
  if (code === "unauthenticated") return "กรุณาเข้าสู่ระบบใหม่เพื่อใช้งานรีวิว";
  if (code === "permission-denied") return "ไม่สามารถดำเนินการกับรีวิวนี้ได้ กรุณาตรวจสอบสิทธิ์ของบัญชี";
  if (code === "not-found") return "ไม่พบรีวิวนี้แล้ว กรุณาโหลดรายการใหม่";
  if (code === "resource-exhausted") return "ทำรายการบ่อยเกินไป กรุณารอสักครู่แล้วลองใหม่";
  if (code === "failed-precondition") return "ระบบรีวิวยังไม่พร้อมใช้งาน กรุณาลองใหม่ภายหลัง";
  return "ดำเนินการไม่สำเร็จ กรุณาลองอีกครั้ง ข้อความร่างของคุณยังอยู่";
}

// Client feedback mirrors the REVIEW-1.B text contract; the callable remains
// authoritative for validation, eligibility, ownership, quotas and timestamps.
export function reviewTextError(value) {
  const length = Array.from(value).length;
  if (length < 10 || length > 2000 || Array.from(value.trim()).length < 10) return "กรุณาเขียนรีวิว 10–2,000 ตัวอักษร";
  if (new Blob([value]).size > 8192) return "ข้อความรีวิวมีขนาดใหญ่เกินไป (ไม่เกิน 8,192 ไบต์)";
  // Reject control characters to match the authoritative backend contract.
  // eslint-disable-next-line no-control-regex
  if (/[\p{Cs}\p{Cf}\x00-\x08\x0b\x0c\x0e-\x1f\x7f-\x9f]/u.test(value)) return "ข้อความมีอักขระที่ไม่รองรับ กรุณาตรวจสอบข้อความ";
  const normalized = value.normalize("NFKC").replace(/[๐-๙]/g, (digit) => String(digit.charCodeAt(0) - 0x0e50));
  // These non-global existence checks can consume the preceding boundary instead
  // of using lookbehind, which Safari before 16.4 cannot parse.
  if (/[\p{L}\p{N}.!#$%&'*+/=?^_`{|}~-]+@[\p{L}\p{N}-]+(?:\.[\p{L}\p{N}-]+)+/u.test(normalized) ||
      /(?:^|\D)\d{9,15}(?!\d)/u.test(normalized) || /(?:^|\D)0[\s().-]*[1-9](?:[\s().-]*\d){7,8}(?!\d)/u.test(normalized) ||
      /(?:^|[^\d\p{L}])\+[1-9](?:[\s().-]*\d){7,14}(?!\d)/u.test(normalized)) return "กรุณาลบหมายเลขโทรศัพท์หรืออีเมลออกจากข้อความรีวิว";
  return "";
}
